<template>
    <v-row>
        <NewAttendee v-model="showNewAttendeeDialog"></NewAttendee>
        <ImporterAttendees v-model="showImporterAttendeesDialog"></ImporterAttendees>
        <SendSms v-model="showSendSms"
                 :filters="filtersSms"
                 type="attendees">
        </SendSms>

        <!--<v-col cols="12">
            <v-row class="py-2 px-4" justify="space-between"  >
                <h2 style="display: inline;" id="title">Asistentes</h2>
                <v-spacer></v-spacer>
                <v-btn color="primary"
                       text
                       @click="showImporterAttendeesDialog = true">
                    Importar asistentes
                </v-btn>
                &lt;!&ndash;<v-btn text color="primary" @click="sendSms()">Enviar SMS</v-btn>&ndash;&gt;
                <v-btn color="primary" @click="newAttendee()">Registrar asistente</v-btn>
            </v-row>
        </v-col>-->

        <v-col class="pt-4" cols="12" >
            <list-attendees @newAttendee="newAttendee()"
                            @showImporterAttendeesDialog="showImporterAttendeesDialog = true">
            </list-attendees>
        </v-col>
    </v-row>
</template>

<script>
import ImporterAttendees from '@/pages/App/Events/dialogs/ImporterAttendees.vue'
import NewAttendee from '@/pages/App/Attendees/dialogs/NewAttendee'
import ListAttendees from '@/pages/App/Attendees/ListAttendees.vue'
import SendSms from '@/components/dialogs/SendSms.vue'
export default {
  components: { ImporterAttendees, ListAttendees, NewAttendee, SendSms },
  data () {
    return {
      filtersSms: {},
      showImporterAttendeesDialog: false,
      showNewAttendeeDialog: false,
      showSendSms: false
    }
  },
  methods: {
    newAttendee () {
      this.showNewAttendeeDialog = true
    },
    sendSms () {
      this.showSendSms = true
    }
  }
}
</script>
